import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { FormSpy } from 'react-final-form';

var AutoSave =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoSave, _React$Component);

  function AutoSave() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AutoSave);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AutoSave)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.save = function (blurredField) {
      var _this$props = _this.props,
          values = _this$props.values,
          save = _this$props.save;
      return save(values, blurredField);
    };

    return _this;
  }

  _createClass(AutoSave, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.active && this.props.active !== nextProps.active) {
        // blur occurred
        this.save(this.props.active);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // render submitting state.
      return null;
    }
  }]);

  return AutoSave;
}(React.Component); // This is not the only way to accomplish auto-save, but it does let us:
// - Use built-in React life-cycle methods to listen for changes
// - Maintain state of when we are submitting
// - Render a message when submitting
// - Pass in save prop nicely


export default (function (props) {
  return React.createElement(FormSpy, Object.assign({}, props, {
    subscription: {
      active: true,
      values: true
    },
    component: AutoSave
  }));
});